export default __webpack_public_path__ + "static/media/pavlaka_20_0-41l.e734500b.jpg";